import createPersistedState from 'vuex-persistedstate'
import * as types from '../mutation-types/content-adapter'

const namespaced = true
export const namespace = 'ContentAdapter'

// state
const state = {
    adapterTag: null,
    adaptedParams: {},
}

// mutations
const mutations = {
    [types.SET_ADAPTER_TAG](s, adapterTag) {
        s.adapterTag = adapterTag
    },
    [types.SET_ADAPTED_PARAMS](s, {adapterTag, contentSetId, params}) {
        s.adaptedParams = {
            ...s.adaptedParams,
            [`${adapterTag}_${contentSetId}`]: params,
        }
    },
}

const actions = {
    setContentAdapterTag({commit}, adapterTag) {
        commit(types.SET_ADAPTER_TAG, adapterTag)
    },
    setContentAdaptedParams({commit}, payload) {
        commit(types.SET_ADAPTED_PARAMS, payload)
    },
}

// getters
const getters = {
    contentAdapterTag: s => {
        return s.adapterTag
    },
    getContentAdaptedParams: s => (adapterTag, contentSetId) => {
        return s.adaptedParams[`${adapterTag}_${contentSetId}`]
    },
}

// plugins
const plugins = [
    createPersistedState({
        key: 'content-adapter',
    })
]

export default {namespaced, namespace, state, mutations, actions, getters, plugins}
